<template>
  <div class="active" @click="goBuy()">
		<div class="main">
      <!-- <div class="goBuy" @click="goBuy()"></div> -->
      <div class="goOut"></div>
    </div>
    <Overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img class="logo" src="@/assets/goDown.png">
      </div>
      <div class="goDownTitle">1.点击右上角"..."</div>
      <div class="goDownTitle">2.选择"在浏览器中打开"</div>
    </Overlay>
  </div>
</template>

<script>
import { Overlay } from 'vant';
export default {
  components: {
    Overlay
  },
  name: 'carrousel',
  data() {
    return {
      show: false
    }
  },
  mounted () {
    // 判断是否是pc端
    let isPc = true;
    let ua = navigator.userAgent.toLowerCase();
    let agents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod"];
    for (let i = 0; i < agents.length; i++) {
      if (ua.indexOf(agents[i]) > 0) {
        isPc = false;
        break;
      }
    };
    if (isPc) {
      // pc端
      window.location.href = 'https://www.synlen.com/#/activityPc?shareCode=';
      return;
    };
  },
  computed: {},
  methods: {
    //跳转vip
    goBuy(){
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isAndroid= u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      if(isIos){
        //ios
        // console.log('ios浏览器')
        if(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"){
          //微信自带的浏览器打开
          this.show=true;
          return;
        }else{
          window.location.href = 'https://apps.apple.com/cn/app/id1601918648';
        }
      }else if(isAndroid){
        //安卓
        // console.log('安卓浏览器')
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
      };
    },
    //跳转
    goOut(){
      //跳转抖音app
      window.open('https://v.douyin.com/UAEm5Vb/')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.active{
  width: 100vw;
  height: 100vh;
  background-color: #7140fc;
}
.main{
	width: 100vw;
	height: 1624px;
	background: url("~@/assets/active/activebg.jpg") no-repeat;
	background-size: 100% 100%;
	position: relative;
	.goBuy{
		width: 180px;
		height: 50px;
		position: absolute;
		top: 980px;
		left: 280px;
    // background-color: green;
	}
	.goOut{
		width: 100vw;
		height: 160px;
		position: absolute;
		top: 676px;
		// left: 150px;
    // background-color: green;
	}
}
//下载
.wrapper{
  text-align: right;
  padding: 0 10px;
  .logo{
    width: 250px;
    margin: 40px;
  }
}
.goDownTitle{
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 60px;
  padding: 0 30px;
}
</style>